import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./Student.css";
import logo from "../../../assets/shap_logo2.png";
import eye from "../../../assets/eye.png";
import it_man from "../../../assets/it_man2.png";
import countriesData from "../../../data/countries.json";
import "../../Navbar/Navbar.css";
import axios from "axios";
import swal from "sweetalert";

const StudentSignup = () => {
 const [toggleShowNav, setToggleShowNav] = useState(false);

 const toggleNavDisplay = () => {
  setToggleShowNav((e) => !e);
 };

 const [firstName, setfirstName] = useState("");
 const [lastName, setlastName] = useState("");
 const [phoneNumber, setPhoneNumber] = useState("");
 const [referrerID, setReferrerID] = useState("");
 const [email, setEmail] = useState("");
 const [country, setCountry] = useState("");
 const [states, setStates] = useState("");
 const [password, setPassword] = useState("");
 const [viewPassword, setViewPassword] = useState(false);
 const [stateOfOrigin, setStateOfOrigin] = useState();
 const [canBeSubmitted, setCanBeSubmitted] = useState(false);
 const [loading, setLoading] = useState(false);

 let emailSuccess = "";

 useEffect(() => {
  document.querySelector("#state").selectedIndex = 0;
 }, [country]);

 const resetForm = () => {
  setfirstName("");
  setlastName("");
  setEmail("");
  setPhoneNumber("");
  setPassword("");
  setCountry("");
  setStateOfOrigin("");
  setReferrerID("");
  document.querySelector("#country").selectedIndex = 0;
  document.querySelector("#state").selectedIndex = 0;
 };

 const signUp = async () => {
  setLoading(true);
  try {
   const response = await axios.post(
    process.env.REACT_APP_BASEURL +
     `/api/v1/student/register?referralId=${referrerID}`,
    // `http://localhost:5000/api/v1/student/register?referralId=${referrerID}`,
    {
     firstName,
     lastName,
     email,
     password,
     phoneNumber,
     country,
     stateOfOrigin,
    }
   );
   if (response.data.message === "You're in!") {
    emailSuccess = email;
    resetForm();
   }
   setLoading(false);
   if (!response.data.error) {
    swal({
     title: response.data.message,
     icon: "success",
     text: `Verify your email, we have sent an email to ${emailSuccess}, you need to verify your email to continue. If the verification email is not in your inbox, please check your Spam folder`,
     button: "Ok",
     dangerMode: false,
     closeOnClickOutside: false,
     closeOnEsc: false,
    }).then((ok) => {
     if (ok) {
      window.location.assign("https://shap.netlify.com/affiliate/login");
     }
    });
   } else {
    swal(
     response.data.error ? "Ooops!" : "You're In!",
     response.data.message,
     response.data.error ? "error" : "success"
    );
   }
  } catch (error) {
   if (error.response) {
    console.log(error.response);
    if (error.response.message) {
     let responseError = error.response.data;
     swal("Ooops!", responseError.message, "error");
     setLoading(false);
    } else {
     swal("Ooops!", "An error occured, please try again", "error");
     setLoading(false);
    }
    return;
   } else {
    swal("Ooops!", error.message, "error");

    setLoading(false);
   }
  }
 };

 useEffect(() => {
  if (
   firstName !== null &&
   firstName !== "" &&
   lastName !== null &&
   lastName !== "" &&
   country !== null &&
   country !== "" &&
   stateOfOrigin !== "" &&
   stateOfOrigin !== null &&
   phoneNumber !== null &&
   phoneNumber !== "" &&
   password !== null &&
   password !== ""
  ) {
   setCanBeSubmitted(true);
  } else {
   setCanBeSubmitted(false);
  }
 }, [firstName, lastName, phoneNumber, password, country, stateOfOrigin]);

 useEffect(() => {
  document
   .querySelector(".sidebar .smooth-scroll")
   .addEventListener("click", toggleNavDisplay);
  document
   .querySelector(".mobile-menu")
   .addEventListener("click", toggleNavDisplay);
 }, []);

 useEffect(() => {
  const i = countriesData.filter((item) => item.name === country);

  if (Boolean(i.length > 0)) {
   setStates(i[0]);
  } else {
   return;
  }
 }, [country]);

 return (
  <div>
   <Helmet>
    <title>Student Signup | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   <div className="navbarShap white">
    <nav className="content">
     <Link to="/">
      <img src={logo} alt="logo" />
     </Link>
     <ul className="desktop">
      <li>
       <Link className="black" to="/">
        Home
       </Link>
      </li>
      <li>
       <Link className="black" to="/affiliate">
        Affiliate
       </Link>
      </li>

      <li>
       <Link className="black" to="/vendor">
        Vendor
       </Link>
      </li>

      <li>
       <Link className="black" to="/pricing">
        Pricing
       </Link>
      </li>

      <li>
       <Link className="black" to="/affiliate/login">
        Login
       </Link>
      </li>
     </ul>

     <div className={toggleShowNav ? "sidebar show" : "sidebar"}>
      <ul>
       <li>
        <Link className="smooth-scroll" to="/">
         Home
        </Link>
       </li>
       <li>
        <Link className="smooth-scroll" to="/affiliate">
         Affiliate
        </Link>
       </li>

       <li>
        <Link className="smooth-scroll" to="/vendor">
         Vendor
        </Link>
       </li>

       <li>
        <Link className="smooth-scroll" to="/pricing">
         Pricing
        </Link>
       </li>

       <li>
        <Link className="smooth-scroll" to="/affiliate/login">
         Login
        </Link>
       </li>
      </ul>
     </div>

     <div className="mobile-menu">
      {!toggleShowNav && (
       <i
        className="fa fa-bars black"
        style={{ fontSize: "20px" }}
        aria-hidden="true"
       ></i>
      )}
      {toggleShowNav && (
       <i
        className="fa fa-times "
        style={{ color: "#ed1c24", fontSize: "20px" }}
        aria-hidden="true"
       ></i>
      )}
     </div>
    </nav>
   </div>
   <div className="signup-affiliate">
    <div className="signup-container">
     <div className="row">
      <div className="col-sm-7 left-content">
       <h4 className="title">Student Sign-up</h4>
       <p>Start your student journey with SHAP</p>

       <form onSubmit={(e) => e.preventDefault()}>
        <div className="form-container">
         <div className="flex">
          <div className="input-container">
           <label htmlFor="firstName">First name</label>
           <input
            type="text"
            id="firstName"
            placeholder="Enter first name"
            value={firstName}
            onChange={(e) => setfirstName(e.target.value)}
           />
          </div>
          <div className="input-container">
           <label htmlFor="lastName">Last name</label>
           <input
            type="text"
            id="lastName"
            placeholder="Enter last name"
            value={lastName}
            onChange={(e) => setlastName(e.target.value)}
           />
          </div>
         </div>

         <div className="input-container">
          <label htmlFor="email">Email</label>
          <input
           type="email"
           id="email"
           placeholder="Enter email"
           value={email}
           onChange={(e) => setEmail(e.target.value)}
          />
         </div>
         <div className="flex">
          <div className="input-container">
           <label htmlFor="phone">Phone number</label>
           <input
            type="text"
            id="phone"
            placeholder="234 7035345753"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
           />
          </div>

          <div className="input-container">
           <label htmlFor="phone">Referrer ID</label>
           <input
            type="text"
            id="referral"
            placeholder="If any"
            value={referrerID}
            onChange={(e) => setReferrerID(e.target.value)}
           />
          </div>
         </div>

         <div className="flex">
          <div className="input-container">
           <label htmlFor="country">Country</label>
           <select
            id="country"
            defaultValue={"Select country"}
            onChange={(e) => {
             setCountry(e.target.value);
            }}
           >
            <option default disabled>
             Select country
            </option>

            {countriesData.map((data, index) => {
             return (
              <option key={index} data-index="index" value={data.name}>
               {data.name}
              </option>
             );
            })}
           </select>
          </div>

          <div className="input-container">
           <label htmlFor="state">State</label>
           <select
            id="state"
            defaultValue={"Select state"}
            onChange={(e) => setStateOfOrigin(e.target.value)}
           >
            <option default disabled>
             Select state
            </option>
            {states &&
             states.states.length > 0 &&
             states.states.map((data, index) => (
              <option key={index} value={data}>
               {data}
              </option>
             ))}
            {states && states.states.length === 0 && (
             <option key={states.name} value={states.name}>
              {states.name}
             </option>
            )}
           </select>
          </div>
         </div>

         <div className="input-container">
          <label htmlFor="password">Password</label>
          <div className="custom-input">
           <input
            type={viewPassword ? "text" : "password"}
            id="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={6}
           />
           <span onClick={() => setViewPassword(!viewPassword)}>
            {!viewPassword && <img src={eye} alt="show" />}
            {viewPassword && <div>Hide</div>}
           </span>
          </div>
         </div>

         {loading && <div className="shapBtn disabled">Signing up...</div>}

         {!canBeSubmitted && !loading && (
          <button className="shapBtn disabled">Signup</button>
         )}
         {canBeSubmitted && !loading && (
          <button className="shapBtn" onClick={signUp}>
           Signup
          </button>
         )}
        </div>
       </form>

       <div className="login-container">
        <p>
         Already have an account? <Link to="/affiliate/login">Login</Link>
        </p>
       </div>
      </div>
      <div className="right-content col-sm-5">
       <img src={it_man} className="img-responsive" alt="it man" />
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default StudentSignup;
